import PendoLoadingIndicator from '../../../../components/loading-indicator/pendo-loading-indicator.vue.js';
import PendoEmptyState from '../../../../components/empty-state/pendo-empty-state.vue.js';
import Note from './note.vue.js';
import NoteInput from './note-input.vue.js';
import get from 'lodash/get.js';
import moment from 'moment-timezone';

var script = {
  name: 'NoteDrawerContent',
  components: {
    PendoLoadingIndicator,
    PendoEmptyState,
    Note,
    NoteInput
  },
  props: {
    activeUser: {
      type: Object,
      required: true
    },
    displayAlert: {
      type: Object,
      default: () => {}
    },
    noteAction: {
      type: Object,
      default: () => ({})
    },
    noteError: {
      type: Object,
      default: () => {}
    },
    hasAdminAccess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeNoteId: undefined,
      fetchingNotes: false
    };
  },
  computed: {
    notes() {
      return get(this.displayAlert, 'notes', []).sort((a, b) => a.createdAt - b.createdAt);
    },
    notesByDay() {
      return this.notes.reduce((map, note) => {
        const dayTimestamp = moment(note.createdAt).startOf('day').tz(moment.tz.guess()).format('dddd, MMM D, YYYY');
        if (map[dayTimestamp]) {
          map[dayTimestamp].notes.push(note);
        } else {
          map[dayTimestamp] = {
            notes: [note],
            key: dayTimestamp
          };
        }
        return map;
      }, {});
    },
    isFetchingNotes() {
      return this.noteAction.fetch;
    }
  },
  watch: {
    isFetchingNotes(newValue, oldValue) {
      if (this.fetchingNotes && oldValue && !newValue) {
        this.$nextTick(() => {
          const element = document.getElementsByClassName('display-alerts-drawer__content')[0];
          element.scrollTop = element.scrollHeight;
        });
        this.fetchingNotes = false;
      }
    },
    displayAlert(newAlert, oldAlert) {
      const newAlertId = get(newAlert, 'alertId');
      const oldAlertId = get(oldAlert, 'alertId');
      if (newAlertId !== oldAlertId) {
        this.fetchNotes(newAlert);
      }
    }
  },
  created() {
    if (this.displayAlert && this.displayAlert.alertId) {
      this.fetchNotes(this.displayAlert);
    }
  },
  methods: {
    fetchNotes(alert) {
      this.fetchingNotes = true;
      this.$emit('fetch-notes', {
        alert
      });
    },
    setActiveNoteId(noteId) {
      this.activeNoteId = noteId;
    },
    createNote(_ref) {
      let {
        alert,
        text
      } = _ref;
      this.$emit('create-note', {
        alert,
        text
      });
    },
    updateNote(_ref2) {
      let {
        alert,
        noteId,
        text
      } = _ref2;
      this.$emit('update-note', {
        alert,
        noteId,
        text
      });
    },
    removeNote(_ref3) {
      let {
        alert,
        noteId
      } = _ref3;
      this.$emit('remove-note', {
        alert,
        noteId
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=note-drawer-content.vue2.js.map
